import { motion } from 'framer-motion'
import clsx from 'clsx'
import { spring } from '../lib/motion'

export type Stage = { n: string; label: string }

// Horizontal stage rail 01→NN (DESIGN.md §5.10). done=leaf, active=accent
// (shared-element slide via layoutId), future=border. Finite motion only.
export function StageRail({ stages, active = 0, className }: { stages: Stage[]; active?: number; className?: string }) {
  return (
    <div className={clsx('stagerail', className)} role="list">
      {stages.map((s, i) => {
        const state = i < active ? 'done' : i === active ? 'active' : 'future'
        return (
          <div key={s.n} className={`stagerail-node is-${state}`} role="listitem">
            <div className="stagerail-dot">
              {state === 'active' && (
                <motion.span layoutId="stage-active" className="stagerail-active" transition={spring.rail} />
              )}
              <span className="stagerail-n mono">{s.n}</span>
            </div>
            <span className="stagerail-label">{s.label}</span>
          </div>
        )
      })}
    </div>
  )
}
